import * as React from 'react';
import { Route, Switch } from 'react-router-dom';

import { DataOwnerRoutes } from './Pages/DataOwners/DataOwnerRoutes';
import { Home } from './Pages/Home/Home';
import { MachineLearningRoutes } from './Pages/MachineLearning/MachineLearningRoutes';
import { ProvisioningRoutes } from './Pages/Provisioning/ProvisioningRoutes';
import { ConsumerRoutes } from './Pages/Subscribers/ConsumerRoutes';

export function Routes(): React.ReactElement {
  return (
    <Switch>
      <Route path="/" exact component={Home} />
      <Route path="/consumers" component={ConsumerRoutes} />
      <Route path="/dataOwners" component={DataOwnerRoutes} />
      <Route path="/machine-learning" component={MachineLearningRoutes} />
      <Route path="/provisioning" component={ProvisioningRoutes} />
    </Switch>
  );
}
